import React from 'react'
import DashboardHeader from './DashboardHeader'
import Sidebar from '../../shared/components/Sidebar'
import Footer from '../common/Footer'

export default function Layout({ children }) {
    return (
        <>
            <DashboardHeader />
            <div className="dashboard flex">
                <Sidebar />
                <div className="px-4 py-3 xl:px-8 xl:py-6 mt-2 w-full">
                    {children}
                </div>
            </div>
            <Footer />
        </>
    )
}
